import { createSelector } from '@reduxjs/toolkit';
import { selectOffersData } from './selectOffersData';

export const selectOffers = createSelector(selectOffersData, ({ offers }) => offers);
